// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-g3nJT4GL"};